import { getApi, patchApi, postApi, putApi } from "./general.service";

// Referidos y socios (app/referrals en boost-api-v3). El base URL ya incluye /v3.
// Como el resto de servicios, los errores se DEVUELVEN (no se lanzan): comprobar
// `resp?.status` y leer `resp?.response?.data?.error` (código snake_case estable).

const qs = (params = {}) => {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== "") q.set(k, v);
  const s = q.toString();
  return s ? `?${s}` : "";
};

// ── Estadísticas y auditoría ────────────────────────────────────────────────
export const getReferralStats = (params) => getApi(`/admin/referrals/stats${qs(params)}`);
export const getReferralAudit = (params) => getApi(`/admin/referrals/audit${qs(params)}`);

// ── Atribuciones ────────────────────────────────────────────────────────────
export const listAttributions = (params) => getApi(`/admin/referrals/attributions${qs(params)}`);
export const getAttribution = (id) => getApi(`/admin/referrals/attributions/${id}`);
export const reviewAttribution = (id, decision, note) =>
  postApi(`/admin/referrals/attributions/${id}/review`, { decision, note });
export const reassignAttribution = (id, codeId, reason) =>
  postApi(`/admin/referrals/attributions/${id}/reassign`, { codeId, reason });

// ── Códigos ─────────────────────────────────────────────────────────────────
export const listCodes = (params) => getApi(`/admin/referrals/codes${qs(params)}`);
export const createCode = (data) => postApi("/admin/referrals/codes", data);
export const updateCode = (id, data) => patchApi(`/admin/referrals/codes/${id}`, data);

// ── Programas y ajustes ─────────────────────────────────────────────────────
export const listPrograms = () => getApi("/admin/referrals/programs");
export const listProgramVersions = (key) => getApi(`/admin/referrals/programs/${key}/versions`);
export const createProgramDraft = (key, notes) => postApi(`/admin/referrals/programs/${key}/drafts`, { notes });
export const updateProgramDraft = (key, version, params, notes) =>
  putApi(`/admin/referrals/programs/${key}/drafts/${version}`, { params, notes });
export const getProgramDiff = (key, version) => getApi(`/admin/referrals/programs/${key}/drafts/${version}/diff`);
export const publishProgram = (key, version, reason) =>
  postApi(`/admin/referrals/programs/${key}/drafts/${version}/publish`, { reason });
export const getReferralSettings = () => getApi("/admin/referrals/settings");
export const updateReferralSettings = (settings, version, reason) =>
  putApi("/admin/referrals/settings", { settings, version, reason });

// ── Recompensas ─────────────────────────────────────────────────────────────
export const listRewards = (params) => getApi(`/admin/referrals/rewards${qs(params)}`);
export const grantManualReward = (userId, days, reason) => postApi("/admin/referrals/rewards", { userId, days, reason });
export const cancelReward = (id, reason) => postApi(`/admin/referrals/rewards/${id}/cancel`, { reason });
export const retryReward = (id) => postApi(`/admin/referrals/rewards/${id}/retry`, {});
